import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const LinedInfo: FunctionalComponent<IIconProps> = ({ width = '20', height = '20', fill = '#666' }) => {
  return (
    /*@ts-ignore*/
    <svg width={width} height={height} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00004C1.33325 4.31814 4.31802 1.33337 7.99992 1.33337C11.6818 1.33337 14.6666 4.31814 14.6666 8.00004C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667ZM7.99989 13.3334C10.9454 13.3334 13.3332 10.9456 13.3332 8.0001C13.3332 5.05458 10.9454 2.66677 7.99989 2.66677C5.05437 2.66677 2.66655 5.05458 2.66655 8.0001C2.66655 10.9456 5.05437 13.3334 7.99989 13.3334ZM7.99992 6.66677C8.36811 6.66677 8.66658 6.96524 8.66658 7.33343V11.3334C8.66658 11.7016 8.36811 12.0001 7.99992 12.0001C7.63173 12.0001 7.33325 11.7016 7.33325 11.3334V7.33343C7.33325 6.96524 7.63173 6.66677 7.99992 6.66677ZM7.99992 5.33331C7.63173 5.33331 7.33325 5.03484 7.33325 4.66665C7.33325 4.29846 7.63173 3.99998 7.99992 3.99998C8.36811 3.99998 8.66658 4.29846 8.66658 4.66665C8.66658 5.03484 8.36811 5.33331 7.99992 5.33331Z"
        fill={fill}
      />
    </svg>
  );
};

export default LinedInfo;
